module.exports = __webpack_public_path__ + "img/hktcmbanner.0eb9f9f7.jpg";